import { z } from 'zod';
import { EventDate, Geo, Image, Link, LocalDate, LocalTime, Seo, Slug, Timestamp, Ulid, Venue, } from './common.js';
import { Category, EventStatus } from './enums.js';
export const SCHEMA_VERSION = 1;
/**
 * A chi è adatto l'evento (docs/03-modello-dati.md §2.1): `kids` pensato per i bambini
 * (laboratori, spettacoli, animazione), `family` per tutti con qualcosa per i piccoli, `none`
 * nessuna indicazione. Lo decide l'AI (compito `audience`) o la redazione; assente = da valutare.
 */
export const Audience = z.enum(['kids', 'family', 'none']);
/** Evento pubblicato (o in bozza/annullato/archiviato). Vedi docs/03-modello-dati.md §2.1. */
export const Event = z
    .object({
    id: Ulid,
    slug: Slug,
    status: EventStatus,
    title: z.string().min(2).max(200),
    category: Category,
    secondaryCategories: z.array(Category).default([]),
    tags: z.array(z.string().max(40)).default([]),
    comuneId: z.string().regex(/^\d{6}$/, 'codice ISTAT a 6 cifre'),
    frazione: z.string().max(120).optional(),
    venue: Venue.optional(),
    geo: Geo,
    dates: z.array(EventDate).min(1),
    startDate: LocalDate,
    endDate: LocalDate,
    description: z.string().max(10000),
    shortDesc: z.string().max(140),
    seo: Seo.optional(),
    image: Image.optional(),
    links: z.array(Link).default([]),
    featured: z.object({ until: LocalDate }).optional(),
    audience: Audience.optional(),
    seriesId: z.string().optional(),
    /**
     * chi si esibisce: slug degli artisti dell'anagrafica (`ARTIST#<slug>`), letti dall'AI
     * (compito `performers`) o scelti dalla redazione (`lockedFields` con `artists`)
     */
    artists: z.array(z.string().max(80)).max(30).optional(),
    organizerId: z.string().optional(),
    lockedFields: z.array(z.string()).default([]),
    /** campo → id della sorgente da cui proviene il valore attuale */
    provenance: z.record(z.string(), z.string()).default({}),
    /** embedding float32 a 256 dimensioni, codificato in base64 */
    embedding: z.string().optional(),
    factsHash: z.string(),
    legacyIds: z.array(z.string()).default([]),
    createdAt: Timestamp,
    updatedAt: Timestamp,
    version: z.int().nonnegative(),
    schemaVersion: z.int().positive(),
})
    .meta({ id: 'Event' });
/** Riga compatta dell'indice JSON degli eventi futuri (docs/03-modello-dati.md §5). */
export const IndexEvent = z
    .object({
    id: Ulid,
    slug: Slug,
    title: z.string(),
    category: Category,
    comuneId: z.string(),
    frazione: z.string().optional(),
    lat: z.number(),
    lng: z.number(),
    dates: z.array(LocalDate).min(1),
    /** orari di inizio allineati a `dates` (null: senza orario); assente se nessuno ha l'orario */
    starts: z.array(LocalTime.nullable()).optional(),
    startDate: LocalDate,
    endDate: LocalDate,
    shortDesc: z.string(),
    thumb: z.string().optional(),
    featured: z.boolean().optional(),
    /** per bambini o per famiglie (gli altri non lo hanno) */
    audience: z.enum(['kids', 'family']).optional(),
    /** chi si esibisce (slug dell'anagrafica): pagine `/artists` e "Chi c'è" */
    artists: z.array(z.string()).optional(),
    status: z.enum(['published', 'cancelled']),
})
    .meta({ id: 'IndexEvent' });
//# sourceMappingURL=event.js.map